import MT5Notification from './mt5-notification';
import './mt5-notification.scss';

export default MT5Notification;
